import React, { useState, useRef, useEffect } from "react";
import {
  NodeDefinition,
  MakinaProcess,
  NodeElement,
  NodeType,
  ProcessDefinition,
  RegsitryLink,
  SaveJsonResult,
  BaseNodeDefinition,
  ActivityNodeDefinition,
  LinkDefinition,
} from "../interface";
import BpmnModeler from "bpmn-js/lib/Modeler";
import $ from "jquery";
// @ts-ignore
import "./style.css";
// @ts-ignore
import "bpmn-js/dist/assets/diagram-js.css";
// @ts-ignore
import "bpmn-js/dist/assets/bpmn-js.css";
// @ts-ignore
import "bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css";
// @ts-ignore
import "@bpmn-io/properties-panel/assets/properties-panel.css";
import {
  BpmnPropertiesPanelModule,
  BpmnPropertiesProviderModule,
} from "bpmn-js-properties-panel";
import caseModdleExtension from "../descriptors/case.json";
import CaseModule from "../provider/case";
import { ModdleElement } from "bpmn-js/lib/BaseModeler";
import FormioModule from "../provider/form";
import formioModdleDescriptor from "../descriptors/formioDescriptor.json";
import { GoogleGenerativeAI } from "@google/generative-ai";

const GEMINI_API_KEY = "AIzaSyDZbMqscGD9wp4TyshGcYBRKM3Mhe0Tl1Y";

const GEMINI_MODELS_FALLBACK = [
  "gemini-2.0-flash",
  "gemini-2.0-flash-lite",
  "gemini-1.5-flash-latest",
  "gemini-1.5-flash-8b",
];

const GEMINI_MODEL_BLACKLIST = [
  "tts",
  "image",
  "vision",
  "audio",
  "embedding",
  "aqa",
];

async function fetchAvailableGeminiModels(): Promise<string[]> {
  try {
    const res = await fetch(
      "https://generativelanguage.googleapis.com/v1beta/models?key=" +
        GEMINI_API_KEY,
    );
    if (!res.ok) return GEMINI_MODELS_FALLBACK;
    const data = await res.json();
    const available: string[] = (data.models || [])
      .filter((m: any) =>
        (m.supportedGenerationMethods || []).includes("generateContent"),
      )
      .map((m: any) => (m.name as string).replace("models/", ""))
      .filter((name: string) => {
        const n = name.toLowerCase();
        return (
          n.includes("gemini") &&
          !GEMINI_MODEL_BLACKLIST.some((bad) => n.includes(bad))
        );
      });
    console.log("Modèles Gemini texte disponibles :", available);
    return available.length > 0 ? available : GEMINI_MODELS_FALLBACK;
  } catch {
    return GEMINI_MODELS_FALLBACK;
  }
}

const diagramXML = `<?xml version="1.0" encoding="UTF-8"?>
<bpmn2:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn2="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" id="Definitions_1" targetNamespace="http://bpmn.io/schema/bpmn" exporter="Camunda Modeler" exporterVersion="4.1.0" xsi:schemaLocation="http://www.omg.org/spec/BPMN/20100524/MODEL BPMN20.xsd">
  <bpmn2:process id="Process_1" isExecutable="false">
  </bpmn2:process>
  <bpmndi:BPMNDiagram id="BPMNDiagram_1">
    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1">
    </bpmndi:BPMNPlane>
  </bpmndi:BPMNDiagram>
</bpmn2:definitions>`;

var modeler: BpmnModeler;
var filename = "diagram";

function formatJson(value: any): any {
  if (!value) return value;
  try {
    return JSON.parse(JSON.stringify(value));
  } catch {
    return value;
  }
}

function stringify(value: any): string {
  if (!value) return "";
  if (typeof value === "string") return value;
  try {
    return JSON.stringify(value);
  } catch {
    return "";
  }
}

function cleanAndValidateXml(raw: string): string | null {
  let xml = raw
    .replace(/```xml\s*/gi, "")
    .replace(/```\s*/g, "")
    .trim();
  const xmlStart = xml.indexOf("<?xml");
  const defStart = xml.indexOf("<bpmn2:definitions");
  const startIdx = xmlStart !== -1 ? xmlStart : defStart;
  if (startIdx === -1) return null;
  xml = xml.substring(startIdx);
  const closeTag = "</bpmn2:definitions>";
  const endIndex = xml.indexOf(closeTag);
  if (endIndex !== -1) xml = xml.substring(0, endIndex + closeTag.length);
  return xml.trim();
}

function resolveNodeCode(ref: any): string {
  if (!ref) return "";
  return (
    ref?.businessObject?.code ||
    ref?.businessObject?.id ||
    ref?.code ||
    ref?.id ||
    ""
  );
}

function findProcessElement(rootElements: any[]): any | null {
  if (!rootElements?.length) return null;
  return rootElements.find((el: any) => el.$type === "bpmn:Process") || null;
}

const AttachJsonPage: React.FC = () => {
  const modelerRef = useRef<BpmnModeler | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [jsonData, setJsonData] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [aiPrompt, setAiPrompt] = useState<string>("");
  const [isAiLoading, setIsAiLoading] = useState<boolean>(false);
  const [isAuthorized, setIsAuthorized] = useState<boolean>(false);
  const [isCheckingAuth, setIsCheckingAuth] = useState<boolean>(true);
  const WEBADMIN_URL = process.env.REACT_APP_ADMIN_WEB_URL;
  console.log("REACT_APP_ADMIN_WEB_URL: ", WEBADMIN_URL);

  const [isCreateMode, setIsCreateMode] = useState<boolean>(() => {
    return new URLSearchParams(window.location.search).get("mode") === "create";
  });
  const [pendingProcessData, setPendingProcessData] = useState<any>(null);
  const [isFromExternalProcess, setIsFromExternalProcess] = useState<boolean>(
    () => {
      const params = new URLSearchParams(window.location.search);
      return (
        params.get("mode") === "create" || params.get("loading") === "true"
      );
    },
  );
  const [saveNotification, setSaveNotification] = useState<{
    open: boolean;
    message: string;
    type: "success" | "error";
  }>({ open: false, message: "", type: "success" });
  const [showFilterWarning, setShowFilterWarning] = useState<boolean>(false);

  console.log("=== WEBADMIN_URL ===", WEBADMIN_URL);

  useEffect(() => {
    return () => {
      modelerRef.current?.destroy();
      modelerRef.current = null;
    };
  }, []);

  const [isLoadingProcess, setIsLoadingProcess] = useState<boolean>(() => {
    return (
      new URLSearchParams(window.location.search).get("loading") === "true"
    );
  });

  // MODIFIÉ : écoute le token depuis iframe (window.parent) ou popup (window.opener)
  useEffect(() => {
    const timeout = setTimeout(() => {
      console.error("Timeout — pas de token reçu depuis webAdmin");
      setIsAuthorized(false);
      setIsCheckingAuth(false);
    }, 15000);

    const handleAuth = (event: MessageEvent) => {
      console.log("=== Message reçu ===", event.origin, event.data);
      if (event.data?.type !== "AUTH_TOKEN") return;
      clearTimeout(timeout);
      const token = event.data.token;
      if (!token || !isTokenValid(token)) {
        console.error("Token invalide ou expiré");
        setIsAuthorized(false);
      } else {
        console.log("Token valide ✅");
        sessionStorage.setItem("WFE_AUTH_TOKEN", token);
        setIsAuthorized(true);
      }
      setIsCheckingAuth(false);
    };

    window.addEventListener("message", handleAuth);

    // MODIFIÉ : supporte iframe (window.parent) et popup (window.opener)
    const parent = window.parent !== window ? window.parent : window.opener;
    if (parent) {
      console.log("=== Envoi BPMN_READY au parent ===");
      parent.postMessage({ type: "BPMN_READY" }, "*");
    }

    return () => {
      window.removeEventListener("message", handleAuth);
      clearTimeout(timeout);
    };
  }, []);

  // MODIFIÉ : écoute LOAD_PROCESS sans filtre d'origine (cross-domain iframe)
  useEffect(() => {
    const handleMessage = async (event: MessageEvent) => {
      if (event.data?.type !== "LOAD_PROCESS") return;
      try {
        const processData = event.data.payload;
        if (!processData) return;
        setIsLoadingProcess(true);
        setIsFromExternalProcess(true);
        setJsonData(processData);
        setError(null);
        await prepareModeling(processData);
      } catch (err) {
        console.error("Erreur chargement processus :", err);
        setError("Erreur lors du chargement du processus reçu.");
      } finally {
        setTimeout(() => {
          setIsLoadingProcess(false);
        }, 1000);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  var jumpx = 1;
  var topLevel = 100;
  var registries = new Array<RegsitryLink>();
  const topLevel1 = 100;
  const topLevel2 = 200;
  const lefLevel = 180;
  var dir = 1;
  var jump: boolean = true;

  function createModeler(): BpmnModeler {
    if (modelerRef.current) {
      modelerRef.current.destroy();
      modelerRef.current = null;
    }
    const instance = new BpmnModeler({
      container: "#js-canvas",
      propertiesPanel: { parent: "#js-properties-panel" },
      additionalModules: [
        BpmnPropertiesPanelModule,
        BpmnPropertiesProviderModule,
        CaseModule,
      ],
      moddleExtensions: { caseModdleExtension },
    }) as BpmnModeler;
    modelerRef.current = instance;
    modeler = instance;
    return instance;
  }

  const loadOldJson = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const result: ProcessDefinition = JSON.parse(
            e.target?.result as string,
          );
          setJsonData(result);
          prepareModeling(result);
          setError(null);
        } catch (err) {
          console.log(err);
          setError("Invalid JSON file");
          setJsonData(null);
        }
      };
      reader.readAsText(file);
      event.target.value = "";
    }
  };

  const loadMakinaXml = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const result = e.target?.result as string;
          setJsonData(result);
          loadModeling(result);
          setError(null);
        } catch (err) {
          console.log(err);
          setError("Invalid JSON file");
          setJsonData(null);
        }
      };
      reader.readAsText(file);
      event.target.value = "";
    }
  };

  async function prepareModeling(data: ProcessDefinition): Promise<void> {
    const instance = createModeler();
    var container = $("#js-drop-zone");

    const hasNodes = data.nodes && Object.keys(data.nodes).length > 0;
    const hasLinks = data.links && data.links.length > 0;
    if (!hasNodes && !hasLinks && (data as any).definitions) {
      const defRootElements = (data as any).definitions?.rootElements || [];
      const processEl = findProcessElement(defRootElements);
      if (processEl?.flowElements?.length) {
        rebuildFromDefinitions(
          data,
          processEl.flowElements,
          (data as any).definitions,
        );
      }
    }

    const hasPositions = Object.values(data.nodes || {}).some(
      (n: any) => n?.position?.x !== undefined && n?.position?.y !== undefined,
    );

    jumpx = 1;
    topLevel = 100;
    registries = [];
    dir = 1;

    try {
      await instance.importXML(diagramXML);
      container.removeClass("with-error").addClass("with-diagram");

      var overlays = instance.get("overlays") as any,
        canvas = instance.get("canvas") as any,
        elementRegistry = instance.get("elementRegistry") as any,
        modeling = instance.get("modeling") as any;
      const rootElement = canvas.getRootElement();
      const elementFactory = instance.get("elementFactory") as any;
      const process = elementRegistry.get("Process_1") as any;
      modeling.updateProperties(process, { id: data.code });

      addProcessExtentionProperties(process, data);

      const flowElementsIndex: Record<string, string> = {};
      const defRootElements = (data as any).definitions?.rootElements || [];
      const processEl = findProcessElement(defRootElements);
      const flowElements = processEl?.flowElements || [];
      flowElements.forEach((f: any) => {
        if (f.id && f.name) flowElementsIndex[f.id] = f.name;
      });

      const startPos = (data as any)._startEventPosition || { x: 100, y: 100 };
      const startEvent = modeling.createShape(
        { type: "bpmn:StartEvent" },
        startPos,
        rootElement,
      );
      const startEl = flowElements.find(
        (f: any) => f.$type === "bpmn:StartEvent",
      );
      startEvent.businessObject.name = startEl?.name || "Start";

      const specialRegistry: Record<string, string> = {};
      if (startEl?.id) specialRegistry[startEl.id] = startEvent.id;

      const endEventIds = new Set<string>();
      (data.links || []).forEach((link: any) => {
        const targetCode = link.target?.node || "";
        const flowEl = flowElements.find((f: any) => f.id === targetCode);
        if (flowEl?.$type === "bpmn:EndEvent") endEventIds.add(targetCode);
        const nodeData = (data.nodes || {})[targetCode];
        if ((nodeData as any)?.type === "endEvent") endEventIds.add(targetCode);
      });

      endEventIds.forEach((endId) => {
        const flowEl = flowElements.find((f: any) => f.id === endId);
        const endLabel = flowEl?.name || flowElementsIndex[endId] || "End";
        const endNode = elementFactory.createShape({ type: "bpmn:EndEvent" });
        endNode.businessObject.name = endLabel;
        const nodeData = (data.nodes || {})[endId] as any;
        const savedPos = nodeData?.position;
        const diagramShapes =
          (data as any)?.definitions?.diagrams?.[0]?.plane?.planeElement || [];
        const endShape = diagramShapes.find((el: any) =>
          el.id?.includes(endId),
        );
        const x = savedPos?.x ?? endShape?.bounds?.x ?? 150;
        const y = savedPos?.y ?? endShape?.bounds?.y ?? startPos.y + 200;
        modeling.createShape(endNode, { x, y }, process);
        specialRegistry[endId] = endNode.id;
      });

      modeling.updateProperties(process, { name: data.label });

      data?.links?.forEach((link: any, index: number) => {
        {
          jump = true;
          var source = registries.find(
            (element) => element.node.code === link.source?.node,
          );
          var target = registries.find(
            (element) => element.node.code === link.target?.node,
          );
          const sourceSpecialId = specialRegistry[link.source?.node || ""];
          const targetSpecialId = specialRegistry[link.target?.node || ""];

          target?.isIfNode ? (jump = false) : (jump = true);

          if (!hasPositions && registries.length % 15 == 0 && index > 0) {
            dir = -dir;
            topLevel = topLevel + 400;
          }
          if (source?.id) {
            source.output = link.source?.output || "output";
            if (
              source.node.type === NodeType.simple &&
              source.node.service === "IfNode"
            ) {
              source.isIfNode = true;
            }
          }

          if (!source?.id && !sourceSpecialId) {
            const nodeData = (data.nodes || {})[link.source?.node || ""];
            if (
              nodeData &&
              (nodeData as any).type !== "endEvent" &&
              (nodeData as any).type !== "startEvent"
            ) {
              const label =
                flowElementsIndex[link.source?.node || ""] ||
                (nodeData as any).label ||
                nodeData.code ||
                link.source?.node;
              var nodeElement = addNode(
                data,
                link.source?.node || "",
                link.source?.output || "output",
              );
              if (nodeElement.type) {
                const newTask = elementFactory.createShape({
                  type: nodeElement.type,
                });
                newTask.businessObject.name = label || nodeElement.label;
                addActivityExtentionProperties(newTask, nodeElement.node);
                source = {
                  id: newTask.id,
                  isIfNode: nodeElement.isIfNode,
                  node: nodeElement.node,
                  output: nodeElement.output,
                } as RegsitryLink;

                const savedPos = (nodeElement.node as any)?.position;
                const x =
                  hasPositions && savedPos?.x !== undefined
                    ? savedPos.x
                    : lefLevel * jumpx + 200;
                const jumpy =
                  hasPositions && savedPos?.y !== undefined
                    ? savedPos.y
                    : registries.length % 2 == 0
                      ? topLevel + topLevel1
                      : topLevel + topLevel2;

                modeling.createShape(newTask, { x, y: jumpy }, process);
                if (!hasPositions) jumpx += dir;
                if (index === 0) {
                  modeling.connect(startEvent, newTask, {
                    type: "bpmn:SequenceFlow",
                  });
                }
                registries.push(source);
              }
            }
          }

          if (!target?.id && !targetSpecialId) {
            const nodeData = (data.nodes || {})[link.target?.node || ""];
            if (
              nodeData &&
              (nodeData as any).type !== "endEvent" &&
              (nodeData as any).type !== "startEvent"
            ) {
              const label =
                flowElementsIndex[link.target?.node || ""] ||
                (nodeData as any).label ||
                nodeData.code ||
                link.target?.node;
              var nodeElement = addNode(
                data,
                link.target?.node || "",
                link.target?.input || "input",
              );
              if (nodeElement.type) {
                const newTask = elementFactory.createShape({
                  type: nodeElement.type,
                });
                newTask.businessObject.name = label || nodeElement.label;
                addActivityExtentionProperties(newTask, nodeElement.node);
                target = {
                  id: newTask.id,
                  isIfNode: nodeElement.isIfNode,
                  node: nodeElement.node,
                } as RegsitryLink;

                const savedPos = (nodeElement.node as any)?.position;
                const x =
                  hasPositions && savedPos?.x !== undefined
                    ? savedPos.x
                    : lefLevel * jumpx + 200;
                var jumpy =
                  hasPositions && savedPos?.y !== undefined
                    ? savedPos.y
                    : registries.length % 2 == 0
                      ? topLevel + topLevel1
                      : topLevel + topLevel2;
                if (!hasPositions && target.isIfNode) {
                  if (index > 2 && !registries[index - 3]?.isIfNode) {
                    jumpy =
                      registries.length % 2 == 1
                        ? topLevel + topLevel1
                        : topLevel + topLevel2;
                  }
                }
                modeling.createShape(newTask, { x, y: jumpy }, process);
                if (!hasPositions) jumpx += dir;
                registries.push(target);
              }
            }
          }

          const sourceShapeId = source?.id || sourceSpecialId;
          const targetShapeId = target?.id || targetSpecialId;
          if (sourceShapeId && targetShapeId) {
            const sourceNode = elementRegistry.get(sourceShapeId);
            const targetNode = elementRegistry.get(targetShapeId);
            if (sourceNode && targetNode) {
              if (source?.isIfNode) {
                const yesFlow = modeling.connect(sourceNode, targetNode, {
                  type: "bpmn:SequenceFlow",
                });
                modeling.updateProperties(yesFlow, {
                  name: source.output,
                  businessObject: {
                    conditionExpression: {
                      body: "${decision === ${source.output}}",
                      $type: "bpmn:FormalExpression",
                    },
                  },
                });
              } else if (
                !link.source?.output ||
                link.source?.output === "output"
              ) {
                modeling.connect(sourceNode, targetNode, {
                  type: "bpmn:SequenceFlow",
                });
              } else {
                const flow = modeling.connect(sourceNode, targetNode, {
                  type: "bpmn:SequenceFlow",
                });
                modeling.updateProperties(flow, {
                  name: link.source?.output,
                });
              }
            }
          }
        }
      });
    } catch (err: Error | any) {
      container.removeClass("with-diagram").addClass("with-error");
      container.find(".error pre").text(err.message);
      console.error(err);
    }
  }

  async function loadModeling(diagramXML: string): Promise<void> {
    console.log("smak loadModeling", diagramXML);
    const instance = createModeler();
    var container = $("#js-drop-zone");
    try {
      await instance.importXML(diagramXML);
      container.removeClass("with-error").addClass("with-diagram");
    } catch (err: Error | any) {
      container.removeClass("with-diagram").addClass("with-error");
      container.find(".error pre").text(err.message);
      console.error(err);
    }
  }

  function addNode(
    data: ProcessDefinition,
    code: string,
    io: string,
  ): NodeElement {
    var nodeElement: NodeElement = {
      type: "",
      label: "",
      isIfNode: false,
      output: "",
      node: {} as NodeDefinition,
    };
    Object.keys(data?.nodes).forEach((key, index) => {
      if (key === code) {
        const node = data?.nodes[key];
        switch (node.type) {
          case NodeType.activity: {
            nodeElement = {
              type: "bpmn:Task",
              label: node.label || node.code,
              isIfNode: false,
              output: io,
              node: node,
            };
            break;
          }
          case NodeType.service: {
            nodeElement = {
              type: "bpmn:ServiceTask",
              label: node.label || node.code,
              isIfNode: false,
              output: io,
              node: node,
            };
            break;
          }
          case NodeType.simple: {
            if (node.service === "IfNode")
              nodeElement = {
                type: "bpmn:ExclusiveGateway",
                label: node.label || node.code,
                isIfNode: true,
                output: io,
                node: node,
              };
            if (node.service === "JsNode" || node.service === "SQLNode")
              nodeElement = {
                type: "bpmn:ScriptTask",
                label: node.label || node.code,
                isIfNode: false,
                output: io,
                node: node,
              };
            if (node.service === "SubcaseStartNode")
              nodeElement = {
                type: "bpmn:BusinessRuleTask",
                label: node.label || node.code,
                isIfNode: false,
                output: io,
                node: node,
              };
            if (node.service === "RestNode")
              nodeElement = {
                type: "bpmn:ScriptTask",
                label: node.label || node.code,
                isIfNode: false,
                output: io,
                node: node,
              };
            if (node.service === "SendEmailNode")
              nodeElement = {
                type: "bpmn:SendTask",
                label: node.label || node.code,
                isIfNode: false,
                output: io,
                node: node,
              };
            if (node.service === "DocumentTemplateNode")
              nodeElement = {
                type: "bpmn:ServiceTask",
                label: node.label || node.code,
                isIfNode: false,
                output: io,
                node: node,
              };
            if (node.service === "SubcaseEndNode")
              nodeElement = {
                type: "bpmn:EndEvent",
                label: node.label || node.code,
                isIfNode: false,
                output: io,
                node: node,
              };
            if (node.service === "EndNode")
              nodeElement = {
                type: "bpmn:EndEvent",
                label: node.label || node.code,
                isIfNode: false,
                output: io,
                node: node,
              };
            break;
          }
          default:
            return nodeElement;
        }
        return nodeElement;
      }
      return nodeElement;
    });
    return nodeElement;
  }

  function rebuildFromDefinitions(
    data: ProcessDefinition,
    flowElements: any[],
    definitions: any,
  ): void {
    const nodes: Record<string, any> = {};
    const links: any[] = [];
    const diagramShapes = definitions?.diagrams?.[0]?.plane?.planeElement || [];

    const getPosition = (id: string) => {
      const shape = diagramShapes.find(
        (el: any) => el.id === "BPMNShape_" + id || el.id?.includes(id),
      );
      if (!shape?.bounds) return undefined;
      return {
        x: shape.bounds.x,
        y: shape.bounds.y,
        width: shape.bounds.width || 100,
        height: shape.bounds.height || 80,
      };
    };

    flowElements.forEach((flow: any) => {
      const id = flow.id || "";
      const name = flow.name || "";
      const position = getPosition(id);

      if (flow.$type === "bpmn:StartEvent") {
        nodes[id] = { id, code: id, type: "startEvent", label: name, position };
        if (position)
          (data as any)._startEventPosition = { x: position.x, y: position.y };
      } else if (flow.$type === "bpmn:EndEvent") {
        nodes[id] = { id, code: id, type: "endEvent", label: name, position };
      } else if (
        [
          "bpmn:Task",
          "bpmn:UserTask",
          "bpmn:ServiceTask",
          "bpmn:ScriptTask",
          "bpmn:ManualTask",
          "bpmn:BusinessRuleTask",
          "bpmn:SendTask",
          "bpmn:ReceiveTask",
          "bpmn:ExclusiveGateway",
          "bpmn:ParallelGateway",
          "bpmn:InclusiveGateway",
        ].includes(flow.$type)
      ) {
        const nodeType =
          flow.$type === "bpmn:ServiceTask"
            ? NodeType.service
            : NodeType.activity;
        nodes[id] = {
          id,
          code: id,
          type: nodeType,
          service: "",
          label: name,
          params: {},
          start: false,
          initContext: {},
          caseContext: {},
          caseStatus: {},
          caseOwner: {},
          inputs: [],
          outputs: [],
          task: false,
          caseRelationSettings: {},
          retry: {},
          codeTemplate: "",
          owner: "",
          group: "",
          data: {},
          startCondition: {},
          resume: false,
          resumeCondition: {},
          form: {},
          icon: "",
          dataTemplate: "",
          dueAtDuration: {},
          actions: {},
          actionParams: {},
          position,
        };
      } else if (flow.$type === "bpmn:SequenceFlow") {
        const sourceId = flow.sourceRef?.id || flow.sourceRef;
        const targetId = flow.targetRef?.id || flow.targetRef;
        if (sourceId && targetId) {
          links.push({
            source: { node: sourceId, output: flow.name || "output" },
            target: { node: targetId, input: "input" },
          });
        }
      }
    });

    data.nodes = nodes;
    data.links = links;
  }

  function addActivityExtentionProperties(element: any, node: NodeDefinition) {
    const businessObject = element.businessObject;
    if (node.type === NodeType.activity) {
      const n = node as ActivityNodeDefinition;
      businessObject["type"] = node.type || "";
      businessObject["service"] = node.service || "";
      businessObject["codeTemplate"] = n?.codeTemplate || "";
      businessObject["owner"] = stringify(n.owner);
      businessObject["group"] = stringify(n.group);
      businessObject["data"] = stringify(n.data);
      businessObject["startCondition"] = stringify(n.startCondition);
      businessObject["caseContext"] = stringify(node.caseContext);
      businessObject["caseOwner"] = stringify(node.caseOwner);
      businessObject["resume"] = n.resume || false;
      businessObject["resumeCondition"] = stringify(n.resumeCondition);
      businessObject["form"] = stringify(n.form);
      businessObject["icon"] = n.icon || "";
      businessObject["start"] = node.start || false;
      businessObject["dataTemplate"] = n.dataTemplate || "";
      businessObject["code"] = node.code || "";
      businessObject["label"] = n.label || "";
      businessObject["dueAtDuration"] = stringify(n.dueAtDuration);
      businessObject["caseRelationSettings"] = stringify(
        node.caseRelationSettings,
      );
      businessObject["actions"] = stringify(n.actions);
      businessObject["actionParams"] = stringify(n.actionParams);
      businessObject["caseStatus"] = stringify(node.caseStatus);
    } else if (node.type === NodeType.simple) {
      businessObject["service"] = node.service || "";
      businessObject["type"] = node.type || "";
      businessObject["code"] = node.code || "";
      businessObject["label"] = (node as any).label || "";
      businessObject["start"] = node.start || false;
      businessObject["params"] = stringify(node.params);
      businessObject["inputs"] = stringify(node.inputs);
      businessObject["outputs"] = stringify(node.outputs);
      businessObject["caseContext"] = stringify(node.caseContext);
      businessObject["initContext"] = stringify(node.initContext);
      businessObject["task"] = node.task || false;
      businessObject["caseStatus"] = stringify(node.caseStatus);
      businessObject["caseOwner"] = stringify(node.caseOwner);
      businessObject["caseRelationSettings"] = stringify(
        node.caseRelationSettings,
      );
      businessObject["retry"] = node.retry || {};
    } else if (node.type === NodeType.external) {
      businessObject["code"] = node.code || "";
      businessObject["type"] = node.type || "";
      businessObject["label"] = (node as any).label || "";
    }
    return element;
  }

  function addProcessExtentionProperties(
    element: any,
    process: ProcessDefinition,
  ) {
    const businessObject = element.businessObject;
    businessObject["code"] = process?.code || "";
    businessObject["title"] = process.title || "";
    businessObject["label"] = process.label || process.title || "";
    businessObject["codeTemplate"] = stringify(process.codeTemplate);
    businessObject["actions"] = stringify(process.actions);
    businessObject["activityActions"] = stringify(process.activityActions);
    businessObject["forms"] = stringify(process.forms);
    businessObject["form"] = stringify(process.form);
    businessObject["view"] = stringify(process.view);
    businessObject["filterCategory"] = stringify(process.filterCategory);
    businessObject["filters"] = stringify(process.filters);
    return element;
  }

  function parseJson(value: any): any {
    let temp = value.replace(/\\/g, "");
    return temp;
  }

  function isTokenValid(token: string): boolean {
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      const now = Math.floor(Date.now() / 1000);
      return payload.exp && payload.exp > now;
    } catch {
      return false;
    }
  }

  async function downloadBPMNJson() {
    try {
      var bpmnJS = modeler;
      const { xml } = await modeler.saveXML({ format: true });
      var definitions = bpmnJS.getDefinitions();
      const json = await defintion2Json(definitions);
      console.log("smak definitions", definitions);
      const blob = new Blob([json?.json || ""], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename + ".json";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Error saving BPMN XML:", err);
    }
  }

  const newBpmnDiagram = () => {
    try {
      setJsonData(diagramXML);
      loadModeling(diagramXML);
      setError(null);
    } catch (err) {
      console.log(err);
      setError("Invalid JSON file");
      setJsonData(null);
    }
  };

  async function downloadBPMNXML() {
    try {
      const { xml } = await modeler.saveXML({ format: true });
      const blob = new Blob([xml!], { type: "application/xml" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename + ".xml";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Error saving BPMN XML:", err);
    }
  }

  async function defintion2Json(
    definitions: ModdleElement,
  ): Promise<SaveJsonResult> {
    try {
      if (!definitions.rootElements?.length)
        return { error: new Error("Aucun rootElement trouvé") };
      const makinaProcess = new MakinaProcess(definitions);
      const processEl = findProcessElement(definitions.rootElements);
      const bpmnProcess = processEl || definitions.rootElements[0];
      if (!makinaProcess.code) makinaProcess.code = bpmnProcess?.id || "";
      if (!makinaProcess.label)
        makinaProcess.label = bpmnProcess?.name || bpmnProcess?.id || "";
      addNodesAndLinks(makinaProcess, bpmnProcess.flowElements || []);
      filename = makinaProcess.code || "diagram";
      const finalProcess = formatJson(makinaProcess);
      const json = JSON.stringify(finalProcess, null, 2);
      return { json };
    } catch (err) {
      console.error("Error saving BPMN JSON:", err);
    }
    return { error: new Error("Error converting to JSON") };
  }

  // MODIFIÉ : supporte iframe (window.parent) et popup (window.opener)
  function sendToWebAdmin(processData: any) {
    const currentIsCreateMode =
      new URLSearchParams(window.location.search).get("mode") === "create";
    console.log("currentIsCreateMode :", currentIsCreateMode);

    const target = window.parent !== window ? window.parent : window.opener;
    console.log("target :", target);

    if (target && target !== window) {
      const messageType = currentIsCreateMode
        ? "CREATE_PROCESS"
        : "SAVE_PROCESS";
      console.log("Envoi via postMessage, type :", messageType);
      target.postMessage({ type: messageType, payload: processData }, "*");
      setSaveNotification({
        open: true,
        message: "Diagramme envoyé !",
        type: "success",
      });
      return;
    }

    console.error("Pas de parent/opener !");
    setSaveNotification({
      open: true,
      message: "Impossible de contacter webAdmin",
      type: "error",
    });
  }

  async function saveBPMNToAdmin() {
    try {
      var bpmnJS = modeler;
      await modeler.saveXML({ format: true });
      var definitions = bpmnJS.getDefinitions();
      const json = await defintion2Json(definitions);

      if (!json?.json) {
        console.error("Aucun JSON généré");
        return;
      }

      const processData = JSON.parse(json.json);

      if (typeof processData.filterCategory === "string") {
        try {
          processData.filterCategory = JSON.parse(processData.filterCategory);
        } catch {
          processData.filterCategory = [];
        }
      }
      if (typeof processData.filters === "string") {
        try {
          processData.filters = JSON.parse(processData.filters);
        } catch {
          processData.filters = [];
        }
      }

      const hasFilters =
        processData.filters &&
        (Array.isArray(processData.filters)
          ? processData.filters.length > 0
          : Object.keys(processData.filters).length > 0);
      const hasFilterCategory =
        processData.filterCategory &&
        (Array.isArray(processData.filterCategory)
          ? processData.filterCategory.length > 0
          : Object.keys(processData.filterCategory).length > 0);

      if (!hasFilters || !hasFilterCategory) {
        const processCode = processData.code || "process-default";
        if (!hasFilterCategory) {
          processData.filterCategory = [
            {
              code: `${processCode}-category-default`,
              label: "Tous les cas",
              rank: "1",
              icon: "Folder",
              filterCategoryColor: "#1976d2",
              condition: {},
              parentCategoryCode: null,
            },
          ];
        }
        if (!hasFilters) {
          processData.filters = [
            {
              code: `${processCode}-filter-default`,
              label: "Tous",
              icon: "List",
              rank: "1",
              filterCategoryCode: `${processCode}-category-default`,
              filterColor: "#1976d2",
              condition: {},
              schema: { combinator: "and", rules: [] },
            },
          ];
        }
        setPendingProcessData(processData);
        setShowFilterWarning(true);
        return;
      }

      if (!processData.forms) processData.forms = {};
      if (!processData.form) processData.form = [];
      if (!processData.view) processData.view = {};
      if (!processData.actions) processData.actions = {};
      if (!processData.activityActions) processData.activityActions = {};
      if (!processData.priorities) processData.priorities = [];
      if (!processData.title)
        processData.title = processData.label || processData.code;

      sendToWebAdmin(processData);
    } catch (err) {
      console.error("Erreur lors de la sauvegarde :", err);
      setSaveNotification({
        open: true,
        message: "Erreur lors de la sauvegarde",
        type: "error",
      });
    }
  }

  function addNodesAndLinks(
    makinaProcess: MakinaProcess,
    flows: ModdleElement[],
  ) {
    const nodes: Record<string, any> = {};
    const links: any[] = [];
    const elementRegistry = modeler.get("elementRegistry") as any;

    flows.forEach((flow) => {
      if (
        [
          "bpmn:Task",
          "bpmn:UserTask",
          "bpmn:ServiceTask",
          "bpmn:ScriptTask",
          "bpmn:ManualTask",
          "bpmn:BusinessRuleTask",
          "bpmn:SendTask",
          "bpmn:ReceiveTask",
          "bpmn:ExclusiveGateway",
          "bpmn:ParallelGateway",
          "bpmn:InclusiveGateway",
        ].includes(flow.$type)
      ) {
        const node = new ActivityNodeDefinition(flow);
        const nodeCode = node.code || flow.id || "";
        if (!nodeCode) {
          console.warn("Nœud sans code ni id, ignoré :", flow);
          return;
        }
        node.code = nodeCode;
        const nodeLabel = flow.name || node.label || nodeCode;
        node.label = nodeLabel;
        const shape = elementRegistry.get(flow.id);
        const position = shape
          ? {
              x: Math.round(shape.x),
              y: Math.round(shape.y),
              width: Math.round(shape.width),
              height: Math.round(shape.height),
            }
          : undefined;
        nodes[nodeCode] = formatJson({ ...node, label: nodeLabel, position });
      }

      if (flow.$type === "bpmn:StartEvent") {
        const startId = flow.id || "start_event_1";
        const shape = elementRegistry.get(flow.id);
        const position = shape
          ? {
              x: Math.round(shape.x),
              y: Math.round(shape.y),
              width: Math.round(shape.width),
              height: Math.round(shape.height),
            }
          : undefined;
        if (position)
          (makinaProcess as any)._startEventPosition = {
            x: position.x,
            y: position.y,
          };
        nodes[startId] = formatJson({
          id: startId,
          code: startId,
          type: "startEvent",
          label: flow.name || "Début",
          position,
        });
      }

      if (flow.$type === "bpmn:EndEvent") {
        const endId = flow.id || "end_event_1";
        const shape = elementRegistry.get(flow.id);
        const position = shape
          ? {
              x: Math.round(shape.x),
              y: Math.round(shape.y),
              width: Math.round(shape.width),
              height: Math.round(shape.height),
            }
          : undefined;
        nodes[endId] = formatJson({
          id: endId,
          code: endId,
          type: "endEvent",
          label: flow.name || "Fin",
          position,
        });
      }

      if (flow.$type === "bpmn:SequenceFlow") {
        if (!flow.sourceRef || !flow.targetRef) return;
        const sourceCode = resolveNodeCode(flow.sourceRef);
        const targetCode = resolveNodeCode(flow.targetRef);
        if (!sourceCode || !targetCode) {
          console.warn(
            "SequenceFlow : source ou target introuvable :",
            flow.id,
          );
          return;
        }
        links.push(
          formatJson({
            source: { node: sourceCode, output: flow.name || "output" },
            target: { node: targetCode, input: "input" },
          }),
        );
      }
    });

    makinaProcess.nodes = nodes;
    makinaProcess.links = links;
  }

  const handleAiGenerate = async () => {
    console.log("Prompt IA:", aiPrompt);
    if (!aiPrompt) return;

    setIsAiLoading(true);
    setError(null);

    const bpmnPrompt =
      "Tu es un expert BPMN 2.0. Genere UNIQUEMENT le XML BPMN 2.0 valide pour ce processus :\n" +
      aiPrompt +
      "\n\nRegles ABSOLUES :\n" +
      "- Retourne UNIQUEMENT le XML brut, sans markdown, sans backticks, sans explications\n" +
      '- Le XML commence obligatoirement par : <?xml version="1.0" encoding="UTF-8"?>\n' +
      '- Namespaces obligatoires : xmlns:bpmn2="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC"\n' +
      "- Termine obligatoirement par </bpmn2:definitions>\n" +
      "- Chaque bpmndi:BPMNShape DOIT avoir bpmnElement referencant un id existant dans le Process\n" +
      "- Chaque bpmndi:BPMNEdge DOIT avoir bpmnElement referencant un SequenceFlow existant\n" +
      "- Chaque SequenceFlow DOIT avoir sourceRef et targetRef valides\n" +
      "- Tous les tags doivent etre correctement fermes\n" +
      '- Le BPMNPlane doit avoir bpmnElement="[id du Process]"\n' +
      "- Utilise des ids courts et valides (ex: task_1, flow_1, start_1)";

    const genAI = new GoogleGenerativeAI(GEMINI_API_KEY);
    let lastError: any = null;

    const modelsToTry = await fetchAvailableGeminiModels();
    console.log("Modèles Gemini à essayer :", modelsToTry);

    for (const modelName of modelsToTry) {
      try {
        console.log("Tentative Gemini :", modelName);
        const geminiModel = genAI.getGenerativeModel({ model: modelName });
        const result = await geminiModel.generateContent(bpmnPrompt);
        const response = await result.response;
        const text = response.text();
        const cleanedXml = cleanAndValidateXml(text);
        if (!cleanedXml) throw new Error("Réponse Gemini sans XML valide");
        console.log("Succès Gemini :", modelName);
        setJsonData(cleanedXml);
        setError(null);
        await loadModeling(cleanedXml);
        setIsAiLoading(false);
        return;
      } catch (err: any) {
        lastError = err;
        const message: string = err?.message || "";
        const is503 =
          message.includes("503") ||
          message.includes("high demand") ||
          message.includes("overloaded");
        const is404 = message.includes("404") || message.includes("not found");
        const isQuota =
          message.includes("429") ||
          message.includes("quota") ||
          message.includes("rate limit");
        const isWrongModality =
          message.includes("400") &&
          (message.includes("modali") || message.includes("AUDIO"));
        console.warn("Echec Gemini", modelName, ":", message.substring(0, 120));
        if (is404 || isWrongModality) continue;
        if (is503 || isQuota) {
          await new Promise((res) => setTimeout(res, 5000));
          continue;
        }
        break;
      }
    }

    console.log("Tous les modèles Gemini ont échoué, tentative avec Claude...");
    try {
      const claudeResponse = await fetch(
        "https://api.anthropic.com/v1/messages",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            model: "claude-sonnet-4-20250514",
            max_tokens: 4000,
            messages: [{ role: "user", content: bpmnPrompt }],
          }),
        },
      );
      if (!claudeResponse.ok) {
        const errData = await claudeResponse.json().catch(() => ({}));
        throw new Error(
          "Claude API " +
            claudeResponse.status +
            ": " +
            (errData?.error?.message || claudeResponse.statusText),
        );
      }
      const claudeData = await claudeResponse.json();
      const claudeText = (claudeData.content || [])
        .filter((b: any) => b.type === "text")
        .map((b: any) => b.text)
        .join("");
      const cleanedXml = cleanAndValidateXml(claudeText);
      if (!cleanedXml) throw new Error("Réponse Claude sans XML valide");
      console.log("Succès Claude fallback");
      setJsonData(cleanedXml);
      setError(null);
      await loadModeling(cleanedXml);
      setIsAiLoading(false);
      return;
    } catch (claudeErr: any) {
      console.error("Echec Claude fallback :", claudeErr.message);
      setError(
        "Erreur de génération : " +
          (lastError?.message || claudeErr?.message || "Erreur inconnue") +
          ". Veuillez réessayer.",
      );
    }

    setIsAiLoading(false);
  };

  if (isCheckingAuth) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          fontSize: "1.2rem",
          color: "#555",
        }}
      >
        Vérification en cours...
      </div>
    );
  }

  if (!isAuthorized) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          gap: "1rem",
        }}
      >
        <p style={{ fontSize: "1.5rem", color: "#d32f2f", fontWeight: "bold" }}>
          Accès non autorisé
        </p>
        <p style={{ color: "#555", fontSize: "1rem" }}>
          Veuillez accéder à cet éditeur depuis l'application webAdmin.
        </p>
      </div>
    );
  }

  return (
    <>
      {showFilterWarning && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9998,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "12px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
              padding: "2rem 2.5rem",
              maxWidth: "520px",
              width: "90%",
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
            }}
          >
            <p
              style={{
                margin: 0,
                fontSize: "1.2rem",
                fontWeight: "bold",
                color: "#1976d2",
              }}
            >
              Aucun filtre détecté
            </p>
            <p
              style={{
                margin: 0,
                color: "#333",
                fontSize: "1rem",
                lineHeight: "1.6",
              }}
            >
              Ce diagramme ne contient pas de filtre. Un{" "}
              <strong>filtre par défaut</strong> a été ajouté automatiquement.
            </p>
            <div
              style={{
                backgroundColor: "#f5f5f5",
                borderRadius: "8px",
                padding: "1rem",
                fontSize: "0.9rem",
                color: "#555",
                lineHeight: "1.7",
              }}
            >
              <p
                style={{
                  margin: "0 0 0.5rem",
                  fontWeight: "bold",
                  color: "#1976d2",
                }}
              >
                Comment ajouter un filtre dans votre diagramme JSON :
              </p>
              <p style={{ margin: 0 }}>
                Ajoutez une section{" "}
                <code
                  style={{
                    backgroundColor: "#e3f2fd",
                    padding: "0 4px",
                    borderRadius: "3px",
                  }}
                >
                  filters
                </code>{" "}
                dans votre JSON :
              </p>
              <pre
                style={{
                  backgroundColor: "#263238",
                  color: "#80cbc4",
                  padding: "0.8rem",
                  borderRadius: "6px",
                  fontSize: "0.8rem",
                  overflowX: "auto",
                  marginTop: "0.5rem",
                }}
              >
                {`"filterCategory": [{\n  "code": "mon-process-category",\n  "label": "Mes cas",\n  "rank": "1",\n  "icon": "Folder"\n}],\n"filters": [{\n  "code": "mon-process-filter",\n  "label": "Tous les cas",\n  "rank": "1",\n  "filterCategoryCode": "mon-process-category",\n  "condition": {},\n  "schema": {\n    "combinator": "and",\n    "rules": []\n  }\n}]`}
              </pre>
            </div>
            <div
              style={{
                display: "flex",
                gap: "1rem",
                justifyContent: "flex-end",
              }}
            >
              <button
                onClick={() => {
                  setShowFilterWarning(false);
                  if (pendingProcessData) {
                    if (!pendingProcessData.forms)
                      pendingProcessData.forms = {};
                    if (!pendingProcessData.form) pendingProcessData.form = [];
                    if (!pendingProcessData.view) pendingProcessData.view = {};
                    if (!pendingProcessData.actions)
                      pendingProcessData.actions = {};
                    if (!pendingProcessData.activityActions)
                      pendingProcessData.activityActions = {};
                    if (!pendingProcessData.priorities)
                      pendingProcessData.priorities = [];
                    if (!pendingProcessData.title)
                      pendingProcessData.title =
                        pendingProcessData.label || pendingProcessData.code;
                    sendToWebAdmin(pendingProcessData);
                    setPendingProcessData(null);
                  }
                }}
                style={{
                  backgroundColor: "#1976d2",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                  padding: "0.6rem 1.5rem",
                  fontSize: "1rem",
                  cursor: "pointer",
                  fontWeight: "bold",
                }}
              >
                J'ai compris
              </button>
            </div>
          </div>
        </div>
      )}

      {saveNotification.open && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "12px",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.18)",
              padding: "2.5rem 3rem",
              minWidth: "380px",
              maxWidth: "480px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "1rem",
              animation: "popIn 0.3s ease",
            }}
          >
            <div style={{ fontSize: "3rem", lineHeight: 1 }}>
              {saveNotification.type === "success" ? "" : ""}
            </div>
            <p
              style={{
                margin: 0,
                fontWeight: "bold",
                fontSize: "1.4rem",
                color: "#1976d2",
                textAlign: "center",
              }}
            >
              {saveNotification.type === "success"
                ? "Sauvegarde réussie !"
                : "Erreur"}
            </p>
            <p
              style={{
                margin: 0,
                fontSize: "1rem",
                color: "#555",
                textAlign: "center",
                lineHeight: "1.5",
              }}
            >
              {saveNotification.message}
            </p>
            <button
              onClick={() =>
                setSaveNotification({ ...saveNotification, open: false })
              }
              style={{
                marginTop: "0.5rem",
                backgroundColor: "#1976d2",
                color: "white",
                border: "none",
                borderRadius: "6px",
                padding: "0.6rem 2rem",
                fontSize: "1rem",
                cursor: "pointer",
                fontWeight: "bold",
                boxShadow: "0 2px 8px rgba(25, 118, 210, 0.3)",
              }}
            >
              OK
            </button>
          </div>
          <style>{`@keyframes popIn { from { transform: scale(0.85); opacity: 0; } to { transform: scale(1); opacity: 1; } }`}</style>
        </div>
      )}

      {saveNotification.open &&
        (setTimeout(() => {
          setSaveNotification({ ...saveNotification, open: false });
        }, 6000) as any)}

      {isLoadingProcess && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999999999,
            color: "white",
            fontSize: "1.5rem",
            gap: "1rem",
          }}
        >
          <div
            style={{
              width: "50px",
              height: "50px",
              border: "5px solid rgba(255,255,255,0.3)",
              borderTop: "5px solid white",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
            }}
          />
          <p style={{ margin: 0 }}>Génération en cours...</p>
          <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
        </div>
      )}

      <div className="content" id="js-drop-zone">
        {/* MODIFIÉ : section Generate with Makina AI */}
        <div
          className="message intro ai-section"
          style={{
            border: "2px solid #1565C0",
            borderRadius: "10px",
            padding: "14px 20px",
            background: "linear-gradient(135deg, #f0f7ff 0%, #e8f5e9 100%)",
          }}
        >
          <h3
            style={{
              margin: "0 0 10px 0",
              fontSize: "1.2rem",
              fontWeight: "700",
              color: "#1565C0",
              letterSpacing: "0.5px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            Generate with Makina AI
          </h3>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              alignItems: "center",
              width: "100%",
              maxWidth: "600px",
              margin: "0 auto",
            }}
          >
            <textarea
              rows={18}
              placeholder="Décrivez votre processus métier étape par étape..."
              value={aiPrompt}
              onChange={(e) => setAiPrompt(e.target.value)}
              style={{
                width: "100%",
                padding: "10px 12px",
                borderRadius: "8px",
                border: "1.5px solid #1565C0",
                fontFamily: "inherit",
                fontSize: "13px",
                resize: "vertical",
                lineHeight: "1.5",
                boxSizing: "border-box",
                outline: "none",
                backgroundColor: "white",
              }}
            />
            <button
              onClick={handleAiGenerate}
              disabled={isAiLoading}
              style={{
                backgroundColor: isAiLoading ? "#90CAF9" : "#1565C0",
                color: "white",
                border: "none",
                borderRadius: "8px",
                padding: "8px 24px",
                fontSize: "13px",
                fontWeight: "600",
                cursor: isAiLoading ? "not-allowed" : "pointer",
                transition: "background-color 0.2s",
              }}
            >
              {isAiLoading ? "Génération..." : "Générer"}
            </button>
            {error && (
              <p style={{ color: "#d32f2f", margin: 0, fontSize: "13px" }}>
                {error}
              </p>
            )}
          </div>
        </div>

        {/* MODIFIÉ : Upload JSON */}
        <div className="message intro" style={{ padding: "10px 20px" }}>
          <h3
            style={{
              margin: "0 0 8px 0",
              fontSize: "1.1rem",
              fontWeight: "600",
              color: "#1565C0",
            }}
          >
            Upload JSON File
          </h3>
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              padding: "10px 16px",
              border: "2px dashed #1565C0",
              borderRadius: "8px",
              cursor: "pointer",
              backgroundColor: "#f0f7ff",
              transition: "background-color 0.2s",
              fontSize: "13px",
              color: "#1565C0",
              fontWeight: "500",
            }}
          >
            <span style={{ fontSize: "1.2rem" }}></span>
            Choisir un fichier JSON
            <input
              type="file"
              accept=".json"
              onChange={loadOldJson}
              style={{ display: "none" }}
            />
          </label>
          {error && (
            <p
              style={{ color: "#d32f2f", margin: "4px 0 0", fontSize: "12px" }}
            >
              {error}
            </p>
          )}
        </div>

        {/* MODIFIÉ : Upload XML */}
        <div className="message intro" style={{ padding: "10px 20px" }}>
          <h3
            style={{
              margin: "0 0 8px 0",
              fontSize: "1.1rem",
              fontWeight: "600",
              color: "#1565C0",
            }}
          >
            Upload XML File
          </h3>
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              padding: "10px 16px",
              border: "2px dashed #4CAF50",
              borderRadius: "8px",
              cursor: "pointer",
              backgroundColor: "#f1f8e9",
              transition: "background-color 0.2s",
              fontSize: "13px",
              color: "#2E7D32",
              fontWeight: "500",
            }}
          >
            <span style={{ fontSize: "1.2rem" }}></span>
            Choisir un fichier XML
            <input
              type="file"
              accept=".xml"
              onChange={loadMakinaXml}
              style={{ display: "none" }}
            />
          </label>
          {error && (
            <p
              style={{ color: "#d32f2f", margin: "4px 0 0", fontSize: "12px" }}
            >
              {error}
            </p>
          )}
        </div>

        {/* MODIFIÉ : New BPMN Diagram */}
        <div className="message intro" style={{ padding: "10px 20px" }}>
          <h3
            style={{
              margin: "0 0 8px 0",
              fontSize: "1.1rem",
              fontWeight: "600",
              color: "#1565C0",
            }}
          >
            New BPMN Diagram
          </h3>
          <button
            onClick={() => newBpmnDiagram()}
            style={{
              backgroundColor: "white",
              color: "#1565C0",
              border: "2px solid #1565C0",
              borderRadius: "8px",
              padding: "8px 16px",
              fontSize: "13px",
              fontWeight: "600",
              cursor: "pointer",
            }}
          >
            + Create new BPMN Diagram
          </button>
        </div>

        <div className="message error">
          <div className="note">
            <p>Ooops, we could not display the BPMN 2.0 diagram.</p>
            <div className="details">
              <span>cause of the problem</span>
              <pre></pre>
            </div>
          </div>
        </div>

        <div className="canvas" id="js-canvas"></div>
        <div className="properties" id="js-properties-panel"></div>
      </div>

      {jsonData && (
        <ul className="buttons">
          <style>{`
          .buttons button {
            background-color: #1565C0;
            color: white;
            border: none;
            padding: 8px 16px;
            border-radius: 6px;
            cursor: pointer;
            font-size: 13px;
            font-weight: 600;
            transition: background-color 0.2s;
          }
          .buttons button:hover { background-color: #0D47A1; }
        `}</style>
          <li>
            <button onClick={() => window.location.reload()}>← Retour</button>
          </li>
          <li>
            <button onClick={() => downloadBPMNXML()}>⬇ XML</button>
          </li>
          <li>
            <button onClick={() => downloadBPMNJson()}>⬇ JSON</button>
          </li>
          {isFromExternalProcess && (
            <li>
              <button
                onClick={() => saveBPMNToAdmin()}
                style={{ backgroundColor: "#4CAF50" }}
              >
                {isCreateMode ? "Ajouter dans Makina" : "Sauvegarder"}
              </button>
            </li>
          )}
        </ul>
      )}
    </>
  );
};

export default AttachJsonPage;
